<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :aria-labelledby="iconName"
    :class="`icon ${direction} ${isDisabled ? 'is-disabled' : ''}`"
    @click="emitClick"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g :fill="iconColor" :stroke="strokeColor ? strokeColor : ''">
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 21
    },
    height: {
      type: [Number, String],
      default: 21
    },
    iconColor: {
      type: String,
      default: getComputedStyle(document.documentElement).getPropertyValue(
        '--blue__dark'
      )
    },
    direction: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    strokeColor: {
      type: String
    }
  },
  methods: {
    emitClick() {
      if (!this.isDisabled) this.$emit('onClick');
    }
  }
};
</script>

<style scoped>
.icon {
  display: block;
  transition: transform 0.2s linear;
}
.down {
  transform: rotate(270deg);
}
.up {
  transform: rotate(90deg);
}
.is-disabled g {
  fill: var(--gray);
  cursor: default;
}
</style>
